import React from 'react';
import OverrideNavContainer from 'components/nav/renderers/OverrideNavContainer';
import Scorecard from 'components/pure/scorecards/Scorecard';
import './LiveCoaching.styl';
import CallInfoDrawer from 'components/pure/scorecards/live-coaching/CallInfoDrawer';
import {overrideName} from 'components/nav/renderers/LiveCoachingOverrideNav';
import {browserHistory, withRouter} from 'react-router';
import LiveCoachingActions from 'actions/scorecards/LiveCoachingActions';
import LiveCoachingSource from 'sources/scorecards/LiveCoachingSource';
import ExtraReview from 'components/pure/scorecards/live-coaching/ExtraReview';
import {unsavedMessage} from 'utils/const';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';

class LiveCoaching extends React.PureComponent {
  constructor(props) {
    super(props);
    this.routerWillLeave = this.routerWillLeave.bind(this);
    this.state = {finished: false};
  }

  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  }

  routerWillLeave() {
    if (!this.state.finished) {
      return unsavedMessage;
    }
  }

  componentWillUnmount() {
    if (!this.state.finished) {
      this.cleanupPlan();
    }
  }

  // Delete this coaching plan and call metadata if it won't be saved
  cleanupPlan() {
    LiveCoachingActions.reset();
    LiveCoachingSource.delete(this.props.modelId);
    // Don't delete the plan if we're doing a normal coaching review
    if (!this.props.nonAdHoc) {
      CoachingPlanActions.endPlan(this.props.plan.id);
    }
  }

  render() {
    return (
      <div className="live-coaching">
        <CallInfoDrawer
          types={this.props.types}
          nonAdHoc={this.props.nonAdHoc}
          scorecards={this.props.scorecards}
          modelId={this.props.modelId}
          taggedUsers={this.props.taggedUsers}
          answers={this.props.answers}
          model={this.props.model}
          users={this.props.users}
          sessionUser={this.props.sessionUser}
          directions={this.props.directions}
          isEditingScorecard={this.props.isEditing}
          onFinish={cb => {
            this.setState({finished: true}, async () => {
              LiveCoachingActions.reset();
              if (this.props.onSubmit) {
                await this.props.onSubmit();
              }
              if (typeof cb === 'function') {
                cb();
              } else {
                browserHistory.replace(this.props.back);
              }
            });
          }}
          review={this.props.review}
          hasSubmittedScorecards={this.props.hasSubmittedScorecards}
          plan={this.props.plan}
          allScored={
            this.props.scorecards && this.props.scorecards.every(s => !s.results.isEmpty())
          }
        />
        <div className="override-wrapper">
          <OverrideNavContainer />
        </div>
        <div className="scorecard-body-wrapper">
          <Scorecard
            navHeight={60}
            modelId={this.props.modelId}
            title="Scorecard"
            scorecards={this.props.scorecards}
            sessionUser={this.props.sessionUser}
            isOwnCall={false}
            areScorecardResultsToggled={this.props.areScorecardResultsToggled}
            comments={this.props.comments}
            taggedUsers={this.props.taggedUsers}
            reasons={this.props.reasons}
            answers={this.props.answers}
            reasonSchemes={this.props.reasonSchemes}
            schemeLabels={this.props.schemeLabels}
            isSaving={this.props.isSaving}
            scorecardId={this.props.scorecardId}
            topNav={overrideName}
            goBack={() => {
              this.setState({finished: true}, () => {
                this.cleanupPlan();
                browserHistory.replace(this.props.back);
              });
            }}
            onSubmit={LiveCoachingActions.scorecardSubmitted}
            extraReview={isEditing => (
              <ExtraReview
                newSession
                reviewId={this.props.reviewId}
                callId={this.props.modelId}
                isEditing={isEditing}
              />
            )}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(LiveCoaching);
